import  { useContext, useEffect, useState } from "react";
import { Redirect, Route, Switch, useHistory, useRouteMatch } from "react-router-dom";

import Csub from "./comp/homepage/hsonglist";
import Book from "./comp/book/books";
import Bookmark from "./comp/bookmark/bookmarks";

import "@ionic/react/css/core.css";
import { IonContent, IonHeader, IonPage, setupIonicReact, isPlatform, IonToast} from "@ionic/react";
import {
 IonCard,
 IonCardContent,
 IonItem,
 IonItemDivider,
 IonLabel,
 IonRadioGroup,
 IonRadio,
 IonButton,
 IonButtons,
 IonToolbar,
} from "@ionic/react";
import "./styles.css";
import { Colour, Hindit, Bplay, Mode, View, User, Backup, LastBackupTime, AccessToken, BookMark, AddedSongs, SongsHistory, Fsing, UserAudios, HistoryLoaded, HistorySpos, FontType } from "./comp/global";
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { SplashScreen } from "@capacitor/splash-screen";
import { useLocal } from "./comp/lshooks";
import Tsub from "./comp/SP/spsonglist";
import SB from "./comp/SB/sbsonglist";
import { StatusBar  } from '@awesome-cordova-plugins/status-bar';
import HistoryPage from "./comp/bookmark/history";
import axios from "axios";
import AudioPLayer from "./comp/music/audioPlayer";

import { App as CapacitorApp } from '@capacitor/app';
import BackgroundMode from "cordova-plugin-advanced-background-mode";
import { MediaSession } from "@jofr/capacitor-media-session"
 

function App() {
 let history = useHistory();

 const [clr, setClr] = useContext(Colour);
 const [hindit, setHindi] = useContext(Hindit);
 const [iSettings, setSettings] = useLocal("isettings3", "");
 const [, setBplay] = useContext(Bplay);
 const [user, setUser] = useContext(User)
 const [backupDaily, setBackupDaily] = useContext(Backup)
 const [, setLastBackupTime] = useContext(LastBackupTime)
 const [, setAccessToken]  = useContext(AccessToken)
 const [toast, setToast] = useState('false')

 const [bookMark, dispatch] = useContext(BookMark);
 const [addedSongs, ] = useContext(AddedSongs)
 const [songsHistory, ] = useContext(SongsHistory)
 const [fsing] = useContext(Fsing)
 const [userAudios, ] = useContext(UserAudios)
 const [, setLoadAll] = useContext(HistoryLoaded)
 const [, setSpos] = useContext(HistorySpos)

 

 let bcolor, color, color2, color3, colori, colorh, colorsp;
 let { url } = useRouteMatch();
 const [font, ] = useContext(FontType);
 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";
 if(clr === "1") {
    bcolor = "white";
    color = "black";
    color2 = "#00CBFE";
    color3 = "white"
    colori = ""
    colorh = "primary"
    colorsp = "#3880ff"
   }
   if(clr === "2") {
    bcolor = "#FCEFAA";
    color = "black";
    color2 = "#FFE34D";
    color3 = "black"
    colori = "secondary"
    colorh = "warning"
    colorsp = "#F5CA16"
   }
   if(clr === "3") {
    bcolor = "#FCEFAA";
    color = "black";
    color2 = "#FFA500";
    color3 = "black"
    colori = "secondary"
    colorh = "success"
    colorsp = "#FF9933"
   }
   if(clr === "4") {
    bcolor = "#FCEFAA";
    color = "black";
    color2 = "#87CEEB";
    color3 = "black"
    colori = "secondary"
    colorh = "tertiary"
    colorsp = "#6FB1FC"
   }
   if(clr === "5") {
    bcolor = "#121212";
    color = "white";
    color2 = "#FFE34D";
    color3 = "black"
    colori = "dark"
    colorh = "warning"
    colorsp = "#F5CA16"
   }
   if(clr === "6") {
    bcolor = "#121212";
    color = "white";
    color2 = "#87CEEB";
    color3 = "black"
    colori = "dark"
    colorh = "tertiary"
    colorsp = "#6FB1FC"
   }
 const [mode, ] =useContext(Mode);
 const [view, setView] = useContext(View);


 setupIonicReact({
  mode: mode,
  });

 useEffect(() => {
  SplashScreen.hide();
 }, []);

 useEffect(() =>{
  if(isPlatform("android") && !isPlatform("mobileweb")){
  let counter =0;
  let timed = setInterval(()=>{
    counter +=100;
    if (counter > 2000) {
      clearInterval(timed);
    }
    StatusBar.backgroundColorByHexString(colorsp);
    StatusBar.styleDefault();
  },100)
  StatusBar.overlaysWebView(false);
  }
 },[clr])

 useEffect(() => {
  CapacitorApp.addListener('appUrlOpen', (event) => {
    const slug = event.url.split('.app').pop();
    if (slug) {
      history.push(slug);
    }
  });
}, []);


window.addEventListener('beforeunload', function (e) {
  MediaSession.setPlaybackState({playbackState:"none"}).catch((err)=>{console.error(err)})
});

useEffect(()=>{
  if((isPlatform("android") || isPlatform("ios")) && !isPlatform("mobileweb")){
    BackgroundMode.setEnabled(true)
    BackgroundMode.setDefaults({silent:true})
  }
}, [])

 useEffect(() => {
  CapacitorApp.addListener("backButton", (e) => {
    if (window.location.pathname === "/home") {
      MediaSession.setPlaybackState({playbackState:"none"}).catch((err)=>{console.error(err)})
      CapacitorApp.exitApp();
    } else if (window.location.pathname.indexOf("home/songs") !== -1) {
     if(history.length > 1){
      history.goBack()
    }else{
      history.push("/home")
    }
    } else {
      if(window.location.pathname.indexOf("history") !== -1){
        setLoadAll(false)
        setSpos(0)
      }
      if(history.length > 1){
        history.goBack()
      }else{
        history.push(url.slice(0, url.lastIndexOf("/")));
      }
    }
    setBplay({ fold: 0, song: 0 });
   });
 }, []);




 useEffect(()=>{
  async function initializeAuth() {
     try {
        await GoogleAuth.initialize({
           clientId: window.location.hostname.indexOf("vsnectar") !== -1 ? '575794923869-dhsvluik5tfg6n4bviruceds9gbgp7rf.apps.googleusercontent.com':'575794923869-4bv3crbm8t1kb2m9mflk3rrf7qmoa2qm.apps.googleusercontent.com',
           scopes: ['profile', 'email', "https://www.googleapis.com/auth/drive.appdata"],
           grantOfflineAccess: false
         })
       if (user){
         try{
           let data = await GoogleAuth.refresh()
           setAccessToken(data.accessToken)
           let accessToken = data.accessToken
           if(backupDaily) {
            try{
            let listResponse = await axios.get('https://www.googleapis.com/drive/v3/files', {
                params:{
                   spaces:"appDataFolder",
                   fields: 'files(id, name, modifiedTime)'
                },
                headers: {
                   Authorization: 'Bearer ' + accessToken,
                }
             })
             for (let i = 0; i < listResponse.data.files.length; i++) {
                if (listResponse.data.files[i].name === 'vaishnavasongsappdata') {
                   let modifiedTime = new Date(listResponse.data.files[i].modifiedTime)
                   setLastBackupTime(modifiedTime.toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }))
                   if(modifiedTime.setHours(0, 0, 0, 0) === (new Date()).setHours(0, 0, 0, 0)){
                    var file = new Blob(
                        [
                         JSON.stringify({
                          bookmarks: bookMark,
                          addedSongs: addedSongs,
                          songsHistory: songsHistory,
                          fsing: fsing,
                          userAudios: userAudios,
                         }),
                        ],
                        { type: 'application/json' }
                       )
                       var metadata = {
                        name: 'vaishnavasongsappdata',
                        mimeType: 'application/json',
                        parents: ['appDataFolder'],
                       }
                       var formData = new FormData()
                       formData.append(
                        'metadata',
                        new Blob([JSON.stringify(metadata)], {
                         type: 'application/json',
                        })
                       )
                       formData.append('file', file)
                       if (listResponse.data && listResponse.data.files) {
                        for (let i = 0; i < listResponse.data.files.length; i++) {
                         if (listResponse.data.files[i].name === 'vaishnavasongsappdata') {
                          await axios.delete(`https://www.googleapis.com/drive/v3/files/${listResponse.data.files[i].id}`, {
                             headers: {
                                Authorization: 'Bearer ' + accessToken,
                             }
                          })
                         }
                        }
                       }
                        await axios({
                          method: 'post',
                          url: 'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id',
                          headers: {
                           Authorization: 'Bearer ' + accessToken,
                           'Content-Type': 'multipart/form-data',
                          },
                          responseType: 'json',
                          data: formData,
                         })
                       setLastBackupTime((new Date()).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }))                    
                   }
                   return
                }
             }
             
            } catch(err) {
                console.error(err)
                setToast("You have enabled daily data backup, but something went wrong, to fix this please logout and login again to continue your daily data backup")
                setBackupDaily(false)
            }
           }
        } catch(err){
           if (err && (err.type === "userLoggedOut" || err.errorMessage === "User not logged in.")) {
              if(backupDaily){
                setToast("You have enabled daily data backup, but you have been logged out, so please login again to continue your daily data backup")
                setBackupDaily(false)
              }
              setUser(null)
              setLastBackupTime("Not yet saved")
           }
        }
       } else if(backupDaily) {
        setToast("You have enabled daily data backup, but you have been logged out, so please login again to continue your daily data backup")
        setBackupDaily(false)
       }
     } catch (e) {
         console.error(e);
     }
 };
 initializeAuth();
},[])



 useEffect(()=>{
  let oldBookmarks = localStorage.getItem("bookmarks")
  if(oldBookmarks){
    setTimeout(()=>{
      dispatch({ type: "replace", value: JSON.parse(oldBookmarks)});
    },1000)
    localStorage.removeItem("bookmarks")
  }
 },[])

  return (
   <div style={{ backgroundColor: `${bcolor}`, minHeight: "100vh" }}>
    <Switch>
     <Route exact path="/">
      <Redirect to="/home" />
     </Route>
     <Route path="/home">
      <Csub className="nav" />
     </Route>

     <Route path="/books">
      <Book />
     </Route>
     <Route path="/sp">
      <Tsub />
     </Route>
     <Route path="/sb">
      <SB />
     </Route>

     <Route path="/lists">
      <Bookmark/>
     </Route>
     <Route path="/history">
      <HistoryPage />
     </Route>
    </Switch>
   <AudioPLayer colorh={colorh} />
   <IonToast
    onDidDismiss={() => {
     setToast('false')
    }}
    isOpen={toast !== 'false'}
    message={toast}
    duration={4000}
   ></IonToast>
       {iSettings === ""  ? <div>
      {localStorage.getItem('isettings2') ?  <IonPage>
       <IonHeader>
       <IonToolbar style={{ textAlign: "center" }} color={colorh}>
        <IonButtons>
         <IonLabel style={{ fontFamily: `${fon}`, width:"100%", textAlign: "center" }}>
          {hindit ? "वैष्णव गीत ऐप में आपका स्वागत है" : "Welcome Back to the Vaishnava Songs App"}
         </IonLabel>
        </IonButtons>
       </IonToolbar>
       </IonHeader>
       <IonContent color={colori} >
       
        <div style={{ height: "1px" }}></div>
        {!hindit ? <div style={{  textAlign: "left", margin:"0 10px" }}>
      <p>The following features have been added in this update:</p>

      <ul style={{ paddingLeft: "20px" }}>
      <li>More than 30 new songs have been added.</li>
      <li>Audios of many devotees like HH Gour Govinda Swami, HG Radheshyam Prabhu, HG Amarendra Prabhu, etc., have been added.</li>
      <li>You can also add audio from your device, YouTube, SoundCloud, Google Drive, or any MP3 URL.</li>
      <li>Audio will continue playing even if you come out of the song page.</li>
      <li>Now you can copy the text of songs.</li>
      <li>You can Print/PDF and Share a song.</li>
      <li>Advanced search functionality has been improved (you can search using diacritics, view recent searches, etc.).</li>
      <br />
      <li>You can see all the songs in the song book section in a "list" view.</li>
      <li>Audios have been added for some songs in the “Song Books” section and “Bhagavatam Prayers” section.</li>
      <li>Music controls have been added in the "Songs Sung by Srila Prabhupada" section, along with a view to see the actual lyrics of the song.</li>
      <li>The "Songs Sung by Srila Prabhupada" section is now available in Hindi language as well.</li>
      <br />
      <li>"Singers" section has been added, categorizing songs by the singer.</li>
      <li>A section has been added to view your song history, downloaded songs, and added audios.</li>
      <li>Google Drive backup option has been added to save your bookmarks and history.</li>
      <li>Music controls in the notification has been improved.</li>
      <li>Fixed the issue of Bookmarks getting disappeared after some time.</li>
      {isPlatform("ios") ? <li>Added swipe to back gesture</li> : null}
      <li>Many more improvements and bug fixes have been implemented.</li>
      </ul>
     </div> : <div style={{  textAlign: "left", margin:"0 10px" }}>
    
     <p>इस अपडेट में निम्नलिखित विशेषताएँ जोड़ी गई हैं:</p>

     <ul style={{ paddingLeft: "20px" }}>
     <li>बहुत से भक्तों की ऑडियोज़ जैसे कि गौर गोविंद स्वामी महाराज, रादेश्याम प्रभु, अमरेन्द्र प्रभु, आदि, जोड़ी गई हैं।</li>
     <li>आप अपनी डिवाइस, YouTube, SoundCloud, Google Drive, या किसी भी MP3 URL से भी ऑडियो जोड़ सकते हैं।</li>
     <li>ऑडियो गाने के पेज से बाहर निकलते हुए भी चलता रहेगा।</li>
     <li>अब आप गानों का टेक्स्ट कॉपी कर सकते हैं।</li>
     <li>आप गाना प्रिंट/पीडीएफ कर सकते हैं और शेयर कर सकते हैं।</li>
     <li>आप हिंदी टेक्स्ट का उपयोग करके गानों के शीर्षकों की खोज कर सकते हैं।</li>
     <br />
     <li>"श्रील प्रभुपाद द्वारा गाए गए भजनें" अनुभाग अब हिंदी भाषा में भी उपलब्ध है।</li>
     <li>"गायक" अनुभाग जोड़ा गया है, जो गायक द्वारा गानों को वर्गीकृत करता है।</li>
     <li>आपके गाने का हिस्ट्री, डाउनलोड किए गए गाने, और जोड़ी गई ऑडियोज़ को देखने के लिए एक अनुभाग जोड़ा गया है।</li>
     <li>आपके बुकमार्क्स और हिस्ट्री को सेव करने के लिए Google Drive बैकअप ऑप्शन जोड़ा गया है।</li>
     <li>नोटिफिकेशन में संगीत कंट्रोल्स को सुधारा गया है।</li>
     <li>कुछ समय बाद बुकमार्क्स गायब हो जाने की समस्या को ठीक किया गया।</li>
     <li>बहुत सारी और सुधार और बग फिक्स किए गए हैं।</li>
    </ul>
    </div>}
       <div style={{ textAlign: "center" }}>
        <IonButton
         onClick={() => {
          setSettings("done");
          localStorage.removeItem('isettings2')
         }}
         shape="round"
         color={colorh}
        >
         {hindit ? "चलिए शुरू करते हैं" : "Let's Start"}
        </IonButton>
        <div style={{ height: "20px" }}></div>
       </div>

       </IonContent>
      </IonPage>:  <IonPage>
    <IonHeader>
    <IonToolbar style={{ textAlign: "center" }} color={colorh}>
     <IonButtons>
      <IonLabel style={{ fontFamily: `${fon}`, width:"100%", textAlign: "center" }}>
       {hindit ? "वैष्णव गीत ऐप में आपका स्वागत है" : "Welcome to the Vaishnava Songs App"}
      </IonLabel>
     </IonButtons>
    </IonToolbar>
    </IonHeader>
    <IonContent color={colori} >
    
     <div style={{ height: "1px" }}></div>
     <IonCard color={colori} style={{ color: `${color}`, fontFamily: `${fon}`  }}>
      <IonCardContent>
      {!hindit ? <>
      
        {isPlatform("desktop") || isPlatform("mobileweb") ? <p style={{ fontSize: "16px", textAlign: "justify"  }}>
        <b>You don't need to have internet to use this website.</b> You can simply save this URL or bookmark this page and use it like an app.
        </p> : <b style={{ fontSize: "16px", textAlign: "justify"  }}>
          This app works offline and doesn't display any ads.
        </b>}
        <p style={{ fontSize: "16px", textAlign: "justify"  }}>
        This app has many features, but many devotees are unaware of them. So Please try clicking on all the "Buttons/Icons" you see to discover these features.
        </p>
        <p style={{ fontSize: "16px", textAlign: "justify"  }}><b>You can also watch the video tutorial in the side menu bar.</b></p>
      </>:<>
      {!(isPlatform("desktop") || isPlatform("mobileweb")) ?
      <b style={{ fontSize: "16px", textAlign: "justify"  }}>यह ऐप ऑफ़लाइन काम करता है और कोई विज्ञापन नहीं दिखाता है।</b>
      : <p style={{ fontSize: "16px", textAlign: "justify"  }}><b>आपको इस वेबसाइट का उपयोग करने के लिए इंटरनेट की जरूरत नहीं है।</b> आप सिर्फ इस URL को सेव कर सकते हैं या इस पेज को बुकमार्क करके इसे एक ऐप की तरह उपयोग कर सकते हैं।</p>}<p style={{ fontSize: "16px", textAlign: "justify"  }}>
      यह ऐप में कई फीचर हैं, लेकिन कई भक्त उनके बारे में अनजान हैं। इसलिए, कृपया आप जो "बटन / आइकन" देखते हैं, उन पर क्लिक करके इन फ़ीचर्स को खोजने का प्रयास करें।
        </p>
        <p style={{ fontSize: "16px", textAlign: "justify"  }}><b>आप साइड मेन्यू बार में वीडियो ट्यूटोरियल भी देख सकते हैं।</b></p>
        </>}
      </IonCardContent>
     </IonCard>
     <br />
     <div style={{ textAlign: "center" }}>
     <IonButton
      onClick={() => {
       setSettings("done");
      }}
      shape="round"
      color={colorh}
     >
      {hindit ? "चलिए शुरू करते हैं" : "Let's Start"}
     </IonButton>
     <div style={{ height: "20px" }}></div>
    </div>
    <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
     <IonLabel style={{ fontFamily: `${fon}` }}>Language / भाषा</IonLabel>
    </IonItemDivider>
    <IonRadioGroup
     value={hindit}
     onIonChange={(e) => {
      setHindi(e.detail.value);
     }}
    >
     <IonItem  color={colori}>
      <IonRadio style={{ fontFamily: `${fon}` }} value="">English (All Features)</IonRadio>
     </IonItem>

     <IonItem  color={colori}>
      <IonRadio style={{ fontFamily: `${fon}` }} value="1">हिन्दी</IonRadio>
     </IonItem>
    </IonRadioGroup>
    <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
     <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "थीम" : "Theme of the App"} </IonLabel>
    </IonItemDivider>
    <IonRadioGroup
     value={clr}
     onIonChange={(e) => {
      setClr(e.detail.value);
      StatusBar.backgroundColorByHexString(`${e.detail.value ? "#ffc409" : "#3880ff"}`);
      e.detail.value ? StatusBar.styleDefault() : StatusBar.styleLightContent();
     }}
    >
     <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="1">{hindit ? "निताई / बलराम" : "Nitai / Balarama"}</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="2">{hindit ? "निमाई" : "Nimai"}</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="3">{hindit ? "चैतन्य महाप्रभु" : "Caitanya Mahaprabhu"}</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="4">{hindit ? "राधारानी" : "Radharani"}</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="5">{hindit ? "कृष्ण" : "Krishna"}</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="6">{hindit ? "राधा श्यामसुंदर" : "Radha Shyamsundar"}</IonRadio>
    </IonItem>
    </IonRadioGroup>
    <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
    <IonLabel style={{ fontFamily: `${fon}` }}>{hindit ? "गाने के लिए डिफ़ॉल्ट व्यू" : "Default View for the Songs"}</IonLabel>
   </IonItemDivider>
   <IonRadioGroup value={view} onIonChange={(e) => setView(e.detail.value)}>
    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="1">{hindit ? "प्रत्येक गद्य के बाद अनुवाद" : "Translation after each verse"}</IonRadio>
    </IonItem>

    <IonItem  color={colori}>
     <IonRadio style={{ fontFamily: `${fon}` }} value="2">{hindit ? "गीत के बाद अनुवाद" : "Translation after the song"}</IonRadio>
    </IonItem>

    {hindit ? null : (
     <IonItem  color={colori}>
      <IonRadio style={{ fontFamily: `${fon}` }} value="3">Word to Word Meanings</IonRadio>
     </IonItem>
    )}
     </IonRadioGroup>
    <p style={{ fontSize: "12px", margin: 0, padding: "20px", color: `${color}` }}>
     {hindit ? "आप सेटिंग में कभी भी में ऊपर दिए गए प्राथमिकताएं बदल सकते हैं।" : "You can always change the above preferences in the Settings"}
    </p>
    <br />
    <div style={{ textAlign: "center" }}>
     <IonButton
      onClick={() => {
       setSettings("done");
      }}
      shape="round"
      color={colorh}
     >
      {hindit ? "चलिए शुरू करते हैं" : "Let's Start"}
     </IonButton>
     <div style={{ height: "20px" }}></div>
    </div>
    </IonContent>
   </IonPage>}
    </div> : null}
   </div>
  );
}

export default App;
